import { Component, type ErrorInfo, type ReactNode } from "react";

const CHAVE_RECARGA_CHUNK = "i9:recarga-chunk-em";
const INTERVALO_ANTI_LOOP_MS = 15_000;

function erroDeChunk(error: Error): boolean {
  return /failed to fetch dynamically imported module|loading chunk|chunkloaderror|importing a module script failed/i
    .test(`${error.name} ${error.message}`);
}

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
  recarregando: boolean;
}

/** Evita tela branca: atualiza chunks antigos uma vez e exibe recuperação para outros erros. */
export class ErroAplicacaoBoundary extends Component<Props, State> {
  state: State = { error: null, recarregando: false };

  static getDerivedStateFromError(error: Error): State {
    return { error, recarregando: false };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Falha ao renderizar a aplicação.", error, info.componentStack);
    if (!erroDeChunk(error)) return;

    const ultimaRecarga = Number(sessionStorage.getItem(CHAVE_RECARGA_CHUNK) || 0);
    if (Date.now() - ultimaRecarga < INTERVALO_ANTI_LOOP_MS) return;
    sessionStorage.setItem(CHAVE_RECARGA_CHUNK, String(Date.now()));
    this.setState({ recarregando: true });
    window.location.reload();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
        <section style={{ maxWidth: 520, textAlign: "center" }}>
          <h1>{this.state.recarregando ? "Atualizando a plataforma…" : "Não foi possível abrir esta tela"}</h1>
          <p>{this.state.recarregando
            ? "Aguarde enquanto carregamos a versão mais recente."
            : "Recarregue a plataforma. Se o problema continuar, informe o suporte."}</p>
          {!this.state.recarregando && (
            <button type="button" onClick={() => window.location.reload()}>
              Recarregar plataforma
            </button>
          )}
        </section>
      </main>
    );
  }
}
